import { useEffect } from 'react';

export default function useSpreedlyScript(included: boolean) {
  useEffect(() => {
    if (!included) return;
    if (typeof window === 'undefined') return;
    if (window.Spreedly) return; // already loaded

    const script = document.createElement('script');
    script.src = 'https://core.spreedly.com/iframe/iframe-stable.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // optional cleanup — usually unnecessary
    };
  }, [included]);
}
